import {
  Box,
  Button,
  Flex,
  Tabs,
  Text,
} from "@mantine/core";
import { useContext, useEffect, useMemo, useState } from "react";
import SyncContext from "../../../../context/SyncContext";
import IdeaContext from "../../IdeaContext";
import { useAuth0 } from "@auth0/auth0-react";
import { capitalizeFirstLetter } from "../../../../utils/capitalizeFirstLetter";
import React from "react";
import { formatNumberValue } from "../../Funcs";
import { getNestedFieldValue } from "../../helpers/calculateImpactResults";
import DiscoveryContext from "../../../Discovery/DiscoveryContext";
import { SparklesIcon } from "../../../../icons/x-symbol-svgrepo-com";
import BagelAccordionMenu from "../../../general/BagelAccordionMenu";
import { IconCheck } from "@tabler/icons";
import { updateEvidence } from "../../../../api/evidences";
import { showNotification } from "@mantine/notifications";

// Function to evaluate displayIf condition
export const evaluateDisplayIf = (data: any, displayIf: any): boolean => {
  if (!displayIf) return true;

  const value = getNestedFieldValue(data, displayIf.fieldPath);
  switch (displayIf.operator) {
  case 'exists':
    return value !== null && value !== undefined && value !== '' && value !== 'N/A';
  case 'equals':
    return value === displayIf.value;
  case 'notEquals':
    return value !== displayIf.value;
  default:
    return true;
  }
};

const CardInfoTextItem = ({ item, ideaPage, isInAccordian, activeTab, setActiveTab, setDetailsOpened, componentId, setComponentId }: { item: any, ideaPage: boolean, isInAccordian: boolean, activeTab: any, setActiveTab: any, setDetailsOpened: (isOpen: boolean) => void, componentId: string, setComponentId: React.Dispatch<React.SetStateAction<any>> }) => {

  const {
    evidenceDomain,
    ideaInfoTabsConfig,
    components,
    domains,
    allComponents
  } = useContext(SyncContext);

  const ContextToUse: React.Context<any> =
    ideaPage ? IdeaContext : DiscoveryContext;

  const { idea } = useContext(ContextToUse);

  // Generate tabs and content based on ideaInfoTabsConfig
  const tabsConfig = ideaInfoTabsConfig || {};
  const tabKeys = Object.keys(tabsConfig);

  // Filter tabs based on displayIf condition
  const filteredTabs = tabKeys.filter((tabKey) => {
    const tab = tabsConfig[tabKey];
    return evaluateDisplayIf(item, tab.displayIf);
  });
  
  const ideaComponentId = idea?.componentId || null
  const isMlsuggestion: boolean = item?.ml?.mlComponentId ? true : false
  const ideaComponentExists: boolean = idea?.componentObj ? true : false
  /* const mlComponent = components?.flatMap((c:any) => 
    c._id === item?.ml?.mlComponentId
      ? [c] 
      : c.childComponents?.filter((child:any) => child._id === item?.ml?.mlComponentId) || []
  )?.[0] || null; */


  // const mlComponent = item?.mlComponent

  const mlComponent = useMemo(() => {
    if (item?.ml?.mlComponentId) {
      return allComponents.find((comp) => comp._id === item.ml.mlComponentId);
    }
    return null;
  }, [item?.ml?.mlComponentId, allComponents]);

  const isSame = ideaComponentId === item?.ml?.mlComponentId
  const isChild = item?.mlComponent?.parentId === ideaComponentId
  const isParent = idea?.componentObj?.parentId === item?.ml?.mlComponentId
  const warnUser = !isSame && !isChild && !isParent && ideaComponentExists
  useEffect(() => {
    setActiveTab("details");
  }, [setActiveTab])

  const domainComponentMap = domains.map((domain: any) => {
    const childComponents = components
      .filter((comp: any) => comp.domain?.toLowerCase()?.trim() === domain.name?.toLowerCase()?.trim())
      .map((comp: any) => ({
        ...comp,
        id: comp._id,
        childComponents: comp.childComponents || []
      }));

    return {
      ...domain,
      id: domain._id,
      name: domain.name,
      ownerName: domain.ownerName,
      productComponents: childComponents
    };
  });

  const [domain, setDomain] = useState<any>(
    evidenceDomain ? item?.componentObj?.domain : null
  );
  const [productAreaName, setProductAreaName] = useState<any>(
    capitalizeFirstLetter(item.mlComponent?.name) || "Unassigned"
  );
  const isMatch: boolean = item?.match;
  const [owner, setOwner] = useState(item?.owner);
  const [ownerName, setOwnerName] = useState(item?.owner?.name);
  const [ownerId, setOwnerId] = useState(item?.owner?.id);
  const [componentsByDomain, setComponentsByDomain] = useState<any[]>(
    evidenceDomain ? [] : components
  );
  const [selectedComponent, setSelectedComponent] = useState(item?.componentObj);
  const [productAreaId, setProductAreaId] = useState<any>(item.mlComponent._id || "");
  const filterComponentByDomain = (domainValue: string) => {
    const arr: any[] =
      components.filter((s: any) => s.domain === domainValue) || [];
    setComponentsByDomain(arr);
    const filtered =
      allComponents.filter((s: any) => s.domain === domainValue) || [];
    const ids = filtered.map((a: any) => a._id);
    if (!ids.includes(componentId)) {
      setProductAreaName(null);
      setComponentId(null);
    }
  };
  const { loadEvidence } = useContext(ContextToUse);
  const saveProductArea = (productAreaName: string, componentId: string) => {
    setProductAreaName(productAreaName);
    setComponentId(componentId);
  };
  const auth0 = useAuth0();
  const onSelectSave = (type: string, value: string, ownerId = null) => {
    let updatedValue = value;

    if (type === "componentId") {
      const found = allComponents.find((a: any) => a._id === value);
      updatedValue = found?.name;
    }

    if (item) {
      const itemObj = {
        id: item?._id,
        [type]: value,
      };
      if (ownerId) {
        itemObj["ownerId"] = ownerId;
      }

      updateEvidence(item?._id, { componentId: value }, auth0)
        .then(() => {
          showNotification({
            title: `${type === "componentId"
              ? "Product area"
              : type === "priority"
                ? "Priority"
                : "Domain"
            } updated`,
            color: "teal",
            message: `${type === "componentId"
              ? "Product area"
              : type === "priority"
                ? "Priority"
                : "Domain"
            } updated to "${updatedValue}" successfully`,
            icon: <IconCheck size="1.1rem" />,
            autoClose: 1200,
          });
          loadEvidence();
        })
        .catch((e: any) => console.log(e));
    }
  };
  const handleSelect = (item: any) => {
    setProductAreaName(item.name);
    saveProductArea(item.name, item._id);
    onSelectSave("componentId", item._id, item.ownerId);
  };

  const isAiSuggestion = item?.ml?.mlComponentId && !item?.componentObj?._id;


  return (
    <Tabs value={activeTab} onTabChange={(value) => {
      if (isInAccordian) {
        setDetailsOpened(true);
        setTimeout(() => setActiveTab(value), 0);
      } else {
        setActiveTab(value);
      }
    }}>
      {
        isInAccordian &&
        <Tabs.List>
          {/* Hardcoded Details Tab */}
          <Tabs.Tab value="details" sx={{ padding: "16.6px" }}>
            <Text
              ta="left"
              fz={12}
              fw={600}
              color={activeTab === "details" ? "#212529" : "#5C5CEB"}
            >
              Details
            </Text>
          </Tabs.Tab>

          {/* Dynamically Generated Tabs */}
          {filteredTabs.map((tabKey) => {
            const tab = tabsConfig[tabKey];
            return (
              <Tabs.Tab key={tabKey} value={tabKey}>
                <Text
                  ta="left"
                  fz={12}
                  fw={600}
                  color={activeTab === tabKey ? "#212529" : "#5C5CEB"}
                >
                  {tab.label}
                </Text>
              </Tabs.Tab>
            );
          })}
        </Tabs.List>
      }

      {
        !isInAccordian && (
          <>
            {/* Details Tab Panel */}
            <Tabs.Panel value="details" sx={{ overflow: 'auto' }}>
              <Box mt={12}>
                <Flex h={32} align="center">
                  <Text fz={12} h={16} w={120}>
                    Product area
                  </Text>
                  <BagelAccordionMenu
                    selectedComponent={selectedComponent || (isAiSuggestion ? mlComponent : null)}
                    isAiSuggestion={isAiSuggestion}
                    onSelect={(item: any, type: string) => {
                      if (type === 'Domain') {
                        setDomain(item.name);
                        // const domainObject = domains.find((d: any) => d.name == item.name);
                        // if (domainObject?.ownerId) {
                        //   setOwnerName(domainObject.ownerName);
                        //   setOwner(domainObject.ownerId);
                        // }
                        // filterComponentByDomain(item);
                      } else {
                        setProductAreaName(item?.name);
                        setSelectedComponent(item);
                        if (item.ownerId) {
                          setOwnerName(item?.ownerName);
                          setOwnerId(item.ownerId);
                        }
                        handleSelect(item);
                        setProductAreaId(item?._id);
                      }
                    }}
                  >
                    <Flex
                      h="32px"
                      fz={12}
                      sx={{
                        cursor: "pointer",
                        opacity: !domain && evidenceDomain ? 0.5 : 1,
                      }}
                      align="center"
                    >
                      <Button variant="subtle" compact color="gray">
                        <Flex align="center" gap={4}>
                          <Text
                            fz={12}
                            color={
                              ideaPage &&
                                productAreaId &&
                                productAreaId !== idea?.componentObj?._id
                                ? "red"
                                : item.mlComponent._id == productAreaId
                                  ? "#5C5CEB"
                                  : "black"
                            }
                          >
                            {(mlComponent || selectedComponent) && <Text span color={
                              item.mlComponent._id === productAreaId
                                ? warnUser
                                  ? 'red'
                                  : '#5C5CEB' // purple
                                : productAreaId && productAreaId !== idea?.componentObj?._id
                                  ? 'red'
                                  : 'dimmed'
                            }>.../ </Text>} {productAreaName || "Unassigned"}
                          </Text>
                          {item.mlComponent._id == productAreaId && (
                            
                            <Box mb={-3}>
                              <SparklesIcon color={warnUser ? '#DB2525' : '#5B60E3'} />
                            </Box>
                          )}
                        </Flex>
                      </Button>
                    </Flex>
                  </BagelAccordionMenu>
                </Flex>

                {/* */}

                {/* Owner */}
                {/* <Flex h={32} align="center">
                  <Text fz={12} h={16} w={120}>
                        Owner
                  </Text>
                  <Text fz={12}>
                    {item?.owner?.name || "Unassigned"}
                  </Text>
                </Flex> */}
              </Box>
            </Tabs.Panel>

            {/* Dynamically Generated Tabs Panels */}
            {filteredTabs.map((tabKey) => {
              const tab = tabsConfig[tabKey];
              return (
                <Tabs.Panel key={tabKey} value={tabKey}>
                  <Box my={12}>
                    {tab.properties.map((property: any) => {
                      let value = getNestedFieldValue(item, property.fieldPath);

                      if (value === undefined || value === null || value === '') {
                        value = "N/A";
                      } else if (typeof value === 'number') {
                        value = formatNumberValue(value, property.prefix);
                      } else if (typeof value === 'boolean') { // Added boolean check
                        value = value ? "Yes" : "No";
                      }

                      return (
                        <Flex key={property.fieldPath} h={32} align="center">
                          <Text fz={12} h={16} w={120}>
                            {property.label}
                          </Text>
                          <Text fz={12}>{value}</Text>
                        </Flex>
                      );
                    })}
                  </Box>
                </Tabs.Panel>
              );
            })}
          </>
        )}
    </Tabs>
  );
};

export default CardInfoTextItem;